import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HeroMetricComponent} from './hero-metric.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import { DxPopoverModule, DxButtonModule, DxTemplateModule } from 'devextreme-angular';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';

@NgModule({
  declarations: [HeroMetricComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    DxButtonModule,
    DxPopoverModule,
    DxTemplateModule,
    MatButtonModule,
    FontAwesomeModule,
    MatCardModule,
    MatMenuModule,
  ],
  exports: [HeroMetricComponent]
})
export class HeroMetricModule {
   constructor(library: FaIconLibrary) {
  library.addIconPacks(fas);
}
}

